import { countryCodeEnum } from '@/constants/country'

export default {
  data() {
    return {
      solidpayExcludeList: [
        countryCodeEnum.ALBANIA,
        countryCodeEnum.AFGHANISTAN,
        countryCodeEnum.BAHAMAS,
        countryCodeEnum.BARBADOS,
        countryCodeEnum.BOTSWANA,
        countryCodeEnum.BOSNIA_AND_HERZEGOVINA,
        countryCodeEnum.CAMBODIA,
        //Crimea, region of,
        countryCodeEnum.CUBA,
        countryCodeEnum.ETHIOPIA,
        countryCodeEnum.GHANA,
        countryCodeEnum.GUYANA,
        countryCodeEnum.IRAN,
        countryCodeEnum.IRAQ,
        countryCodeEnum.JAMAICA,
        countryCodeEnum.NORTH_KOREA,
        countryCodeEnum.LAOS,
        countryCodeEnum.MAURITIUS,
        countryCodeEnum.MONGOLIA,
        countryCodeEnum.MYANMAR,
        countryCodeEnum.NICARAGUA,
        countryCodeEnum.PAKISTAN,
        countryCodeEnum.PANAMA,
        countryCodeEnum.SRI_LANKA,
        countryCodeEnum.SUDAN,
        countryCodeEnum.SYRIA,
        countryCodeEnum.TRINIDAD_AND_TOBAGO,
        countryCodeEnum.TUNISIA,
        countryCodeEnum.UGANDA,
        countryCodeEnum.VANUATU,
        countryCodeEnum.YEMEN,
        countryCodeEnum.ZIMBABWE,
        countryCodeEnum.CANADA,
        countryCodeEnum.CHINA,
        countryCodeEnum.COLOMBIA,
        countryCodeEnum.ISRAEL,
        countryCodeEnum.UNITED_STATES,
        countryCodeEnum.VENEZUELA,
        countryCodeEnum.BELGIUM,
        countryCodeEnum.BULGARIA,
        countryCodeEnum.CYPRUS,
        countryCodeEnum.MALTA,
      ],
      powercashExcludeList: [
        countryCodeEnum.BELGIUM,
        countryCodeEnum.CANADA,
        countryCodeEnum.ISRAEL,
        countryCodeEnum.TURKEY,
        countryCodeEnum.UNITED_STATES,
        countryCodeEnum.PUERTO_RICO,
        countryCodeEnum.INDIA,
        countryCodeEnum.CUBA,
        countryCodeEnum.IRAN,
        countryCodeEnum.NORTH_KOREA,
        countryCodeEnum.SUDAN,
        countryCodeEnum.SYRIA,
        countryCodeEnum.IRAQ,
        countryCodeEnum.SOMALIA,
        countryCodeEnum.CHINA,
      ],
      worldcardExcludeList: [
        countryCodeEnum.ALBANIA,
        countryCodeEnum.BULGARIA,
        countryCodeEnum.CROATIA,
        countryCodeEnum.GREECE,
        countryCodeEnum.KOSOVO,
        countryCodeEnum.MONTENEGRO,
        countryCodeEnum.MACEDONIA,
        countryCodeEnum.ROMANIA,
        countryCodeEnum.SERBIA,
        countryCodeEnum.SLOVENIA,
        countryCodeEnum.TURKEY,
        countryCodeEnum.BOSNIA_AND_HERZEGOVINA,
        countryCodeEnum.BELARUS,
        countryCodeEnum.MYANMAR,
        countryCodeEnum.COTE_D_IVOIRE,
        countryCodeEnum.CUBA,
        countryCodeEnum.CONGO_REPUBLIC,
        countryCodeEnum.IRAN,
        countryCodeEnum.IRAQ,
        countryCodeEnum.LIBERIA,
        countryCodeEnum.NORTH_KOREA,
        countryCodeEnum.SUDAN,
        countryCodeEnum.SYRIA,
        countryCodeEnum.ZIMBABWE,
        countryCodeEnum.LITHUANIA,
        countryCodeEnum.JAPAN,
        countryCodeEnum.UNITED_STATES,
        countryCodeEnum.RUSSIA,
      ],
      cardPayExcludeList: [
        countryCodeEnum.CUBA,
        countryCodeEnum.IRAN,
        countryCodeEnum.SUDAN,
        countryCodeEnum.SYRIA,
        countryCodeEnum.VENEZUELA,
      ],
      appleSolidpayIncludeList: [
        countryCodeEnum.ALBANIA,
        countryCodeEnum.ALGERIA,
        countryCodeEnum.AMERICAN_SAMOA,
        countryCodeEnum.ANDORRA,
        countryCodeEnum.ANGOLA,
        countryCodeEnum.ANGUILLA,
        countryCodeEnum.ANTARCTICA,
        countryCodeEnum.ANTIGUA_AND_BARBUDA,
        countryCodeEnum.ARMENIA,
        countryCodeEnum.ARUBA,
        countryCodeEnum.AUSTRALIA,
        countryCodeEnum.AZERBAIJAN,
        countryCodeEnum.BAHAMAS,
        countryCodeEnum.BAHRAIN,
        countryCodeEnum.BANGLADESH,
        countryCodeEnum.BARBADOS,
        countryCodeEnum.BELARUS,
        countryCodeEnum.BELIZE,
        countryCodeEnum.BENIN,
        countryCodeEnum.BERMUDA,
        countryCodeEnum.BHUTAN,
        countryCodeEnum.BOLIVIA,
        countryCodeEnum.BOSNIA_AND_HERZEGOVINA,
        countryCodeEnum.BOTSWANA,
        countryCodeEnum.BOUVET_ISLAND,
        countryCodeEnum.BRITISH_INDIAN_OCEAN,
        countryCodeEnum.BRUNEI_DARUSSALAM,
        countryCodeEnum.BURKINA_FASO,
        countryCodeEnum.BURUNDI,
        countryCodeEnum.CAMBODIA,
        countryCodeEnum.CAMEROON,
        countryCodeEnum.CAPE_VERDE,
        countryCodeEnum.CAYMAN_ISLANDS,
        countryCodeEnum.CENTRAL_AFRICAN,
        countryCodeEnum.CHAD,
        countryCodeEnum.CHILE,
        countryCodeEnum.CHRISTMAS_ISLAND,
        countryCodeEnum.COCOS_ISLANDS,
        countryCodeEnum.COMOROS,
        countryCodeEnum.CONGO_DEMOCRATIC,
        countryCodeEnum.CONGO_REPUBLIC,
        countryCodeEnum.COOK_ISLANDS,
        countryCodeEnum.COSTA_RICA,
        countryCodeEnum.COTE_D_IVOIRE,
        countryCodeEnum.CROATIA,
        countryCodeEnum.CYPRUS,
        countryCodeEnum.CZECH_REPUBLIC,
        countryCodeEnum.DENMARK,
        countryCodeEnum.DJIBOUTI,
        countryCodeEnum.DOMINICA,
        countryCodeEnum.DOMINICAN_REPUBLIC,
        countryCodeEnum.ECUADOR,
        countryCodeEnum.EGYPT,
        countryCodeEnum.EL_SALVADOR,
        countryCodeEnum.EQUATORIAL_GUINEA,
        countryCodeEnum.ERITREA,
        countryCodeEnum.ESTONIA,
        countryCodeEnum.ETHIOPIA,
        countryCodeEnum.FALKLAND_ISLANDS,
        countryCodeEnum.FAROE_ISLAND,
        countryCodeEnum.FIJI,
        countryCodeEnum.FINLAND,
        countryCodeEnum.FRENCH_GUIANA,
        countryCodeEnum.FRENCH_POLYNESIA,
        countryCodeEnum.FRENCH_SOUTHERN_TERR,
        countryCodeEnum.GABON,
        countryCodeEnum.GAMBIA,
        countryCodeEnum.GEORGIA,
        countryCodeEnum.GERMANY,
        countryCodeEnum.GHANA,
        countryCodeEnum.GIBRALTAR,
        countryCodeEnum.GREECE,
        countryCodeEnum.GREENLAND,
        countryCodeEnum.GRENADA,
        countryCodeEnum.GUADELOUPE,
        countryCodeEnum.GUAM,
        countryCodeEnum.GUATEMALA,
        countryCodeEnum.GUERNSEY,
        countryCodeEnum.GUINEA,
        countryCodeEnum.GUINEA_BISSAU,
        countryCodeEnum.GUYANA,
        countryCodeEnum.HAITI,
        countryCodeEnum.HEARD_MCDONALD_ISLANDS,
        countryCodeEnum.VATICAN_CITY_STATE,
        countryCodeEnum.HONDURAS,
        countryCodeEnum.HONG_KONG,
        countryCodeEnum.HUNGARY,
        countryCodeEnum.ICELAND,
        countryCodeEnum.IRELAND,
        countryCodeEnum.ISLE_OF_MAN,
        countryCodeEnum.JAMAICA,
        countryCodeEnum.JERSEY,
        countryCodeEnum.JORDAN,
        countryCodeEnum.KAZAKHSTAN,
        countryCodeEnum.KENYA,
        countryCodeEnum.KIRIBATI,
        countryCodeEnum.SOUTH_KOREA,
        countryCodeEnum.KOSOVO,
        countryCodeEnum.KUWAIT,
        countryCodeEnum.KYRGYZSTAN,
        countryCodeEnum.LAOS,
        countryCodeEnum.LATVIA,
        countryCodeEnum.LEBANON,
        countryCodeEnum.LESOTHO,
        countryCodeEnum.LIBERIA,
        countryCodeEnum.LIBYA,
        countryCodeEnum.LIECHTENSTEIN,
        countryCodeEnum.LITHUANIA,
        countryCodeEnum.LUXEMBOURG,
        countryCodeEnum.MACAO,
        countryCodeEnum.MACEDONIA,
        countryCodeEnum.MADAGASCAR,
        countryCodeEnum.MALAWI,
        countryCodeEnum.MALDIVES,
        countryCodeEnum.MALI,
        countryCodeEnum.MALTA,
        countryCodeEnum.MARSHALL_ISLANDS,
        countryCodeEnum.MARTINIQUE,
        countryCodeEnum.MAURITANIA,
        countryCodeEnum.MAURITIUS,
        countryCodeEnum.MAYOTTE,
        countryCodeEnum.MEXICO,
        countryCodeEnum.MICRONESIA,
        countryCodeEnum.MOLDOVA,
        countryCodeEnum.MONACO,
        countryCodeEnum.MONGOLIA,
        countryCodeEnum.MONTENEGRO,
        countryCodeEnum.MONTSERRAT,
        countryCodeEnum.MOROCCO,
        countryCodeEnum.MOZAMBIQUE,
        countryCodeEnum.NAMIBIA,
        countryCodeEnum.NAURU,
        countryCodeEnum.NEPAL,
        countryCodeEnum.NEW_CALEDONIA,
        countryCodeEnum.NEW_ZEALAND,
        countryCodeEnum.NICARAGUA,
        countryCodeEnum.NIGER,
        countryCodeEnum.NIGERIA,
        countryCodeEnum.NIUE,
        countryCodeEnum.NORFOLK_ISLAND,
        countryCodeEnum.NORTH_MARIANA,
        countryCodeEnum.NORWAY,
        countryCodeEnum.OMAN,
        countryCodeEnum.PAKISTAN,
        countryCodeEnum.PALAU,
        countryCodeEnum.PALESTINIAN,
        countryCodeEnum.PANAMA,
        countryCodeEnum.PAPUA_NEW_GUINEA,
        countryCodeEnum.PARAGUAY,
        countryCodeEnum.PERU,
        countryCodeEnum.PHILIPPINES,
        countryCodeEnum.PITCAIRN,
        countryCodeEnum.POLAND,
        countryCodeEnum.PORTUGAL,
        countryCodeEnum.PUERTO_RICO,
        countryCodeEnum.QATAR,
        countryCodeEnum.REUNION,
        countryCodeEnum.ROMANIA,
        countryCodeEnum.RWANDA,
        countryCodeEnum.SAINT_BARTHELEMY,
        countryCodeEnum.ST_HELENA,
        countryCodeEnum.ST_KITTS_NEVIS,
        countryCodeEnum.SAINT_LUCIA,
        countryCodeEnum.SAINT_MARTIN,
        countryCodeEnum.ST_PIERRE_MIQUELON,
        countryCodeEnum.SAINT_VINCENT_AND_THE_GRENADINES,
        countryCodeEnum.SAMOA,
        countryCodeEnum.SAN_MARINO,
        countryCodeEnum.SAO_TOME_PRINCIPE,
        countryCodeEnum.SAUDI_ARABIA,
        countryCodeEnum.SENEGAL,
        countryCodeEnum.SERBIA,
        countryCodeEnum.MONTENEGRO,
        countryCodeEnum.SEYCHELLES,
        countryCodeEnum.SIERRA_LEONE,
        countryCodeEnum.SINGAPORE,
        countryCodeEnum.SINT_MAARTEN,
        countryCodeEnum.SLOVAKIA,
        countryCodeEnum.SOLOMON_ISLANDS,
        countryCodeEnum.SOMALIA,
        countryCodeEnum.SOUTH_AFRICA,
        countryCodeEnum.SOUTH_GEORGIA,
        countryCodeEnum.SOUTH_SUDAN,
        countryCodeEnum.SRI_LANKA,
        countryCodeEnum.SURINAME,
        countryCodeEnum.SVALBARD,
        countryCodeEnum.SWAZILAND,
        countryCodeEnum.SWEDEN,
        countryCodeEnum.TAIWAN,
        countryCodeEnum.TAJIKISTAN,
        countryCodeEnum.TANZANIA,
        countryCodeEnum.THAILAND,
        countryCodeEnum.TIMOR_LESTE,
        countryCodeEnum.TOGO,
        countryCodeEnum.TOKELAU,
        countryCodeEnum.TONGA,
        countryCodeEnum.TRINIDAD_AND_TOBAGO,
        countryCodeEnum.TUNISIA,
        countryCodeEnum.TURKEY,
        countryCodeEnum.TURKMENISTAN,
        countryCodeEnum.TURKS_AND_CAICOS_ISLANDS,
        countryCodeEnum.TUVALU,
        countryCodeEnum.UGANDA,
        countryCodeEnum.UKRAINE,
        countryCodeEnum.UNITED_ARAB_EMIRATES,
        countryCodeEnum.UNITED_STATES,
        countryCodeEnum.URUGUAY,
        countryCodeEnum.UZBEKISTAN,
        countryCodeEnum.VANUATU,
        countryCodeEnum.VIETNAM,
        countryCodeEnum.VIRGIN_ISLANDS,
        countryCodeEnum.VIRGIN_ISLANDS_US,
        countryCodeEnum.WALLIS_FUTUNA,
        countryCodeEnum.WESTERN_SAHARA,
        countryCodeEnum.YEMEN,
        countryCodeEnum.ZAMBIA,
        countryCodeEnum.ZIMBABWE,
        countryCodeEnum.FRANCE,
        countryCodeEnum.INDONESIA,
        countryCodeEnum.NETHERLANDS_ANTILLES,
        countryCodeEnum.UNITED_KINGDOM,
        countryCodeEnum.ARGENTINA,
        countryCodeEnum.AUSTRALIA,
        countryCodeEnum.BULGARIA,
        countryCodeEnum.CHINA,
        countryCodeEnum.COLOMBIA,
        countryCodeEnum.ITALY,
        countryCodeEnum.JAPAN,
        countryCodeEnum.MYANMAR,
        countryCodeEnum.NETHERLANDS,
        countryCodeEnum.SLOVENIA,
        countryCodeEnum.SWITZERLAND,
      ],
    }
  },
  computed: {
    countryCode() {
      return parseInt(this.$store.state.common.countryCode)
    },
    showSolidpay() {
      return !this.solidpayExcludeList.includes(parseInt(this.countryCode))
    },
    showPowercash() {
      return !this.powercashExcludeList.includes(parseInt(this.countryCode))
    },
    showWorldcard() {
      return !this.worldcardExcludeList.includes(parseInt(this.countryCode))
    },
    showVirtualPay() {
      // return this.countryCode == countryCodeEnum.CANADA
      return false
    },
    showCardPay() {
      return !this.cardPayExcludeList.includes(parseInt(this.countryCode))
    },
    showCC() {
      return this.showSolidpay || this.showPowercash || this.showVirtualPay || this.showCardPay
    },
    showAppleSolidpay() {
      //only safari show
      return this.appleSolidpayIncludeList.includes(parseInt(this.countryCode)) && this.isSafari
    },
    isSafari() {
      return (
        navigator.vendor &&
        navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') == -1 &&
        navigator.userAgent.indexOf('FxiOS') == -1
      )
    },
  },
}
